<template>
  <div class="list-rank">
    <div class="public-main flex title-box">
      <div class="S8 T3 item-rank">名次</div>
      <div class="S8 T3 list-guest">嘉宾</div>
      <div class="S8 T3 list-num">票数</div>
    </div>
    <div
      class="public-main flex"
      v-for="(item, index) in rankList"
      :key="index"
    >
      <div class="S8 T1 item-rank">
        {{ String(item.rank).padStart(2, '0') }}
      </div>
      <div
        class="S8 list-guest guest-bg flex"
        :class="{ 'is-odd': index % 2 == 0 }"
      >
        <img :src="item.avatar" />
        <span class="S8 T1">{{ item.authorName }}</span>
      </div>
      <div class="S8 T1 list-num">{{ item.votes }}</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    rankList: {
      type: Array,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: []
    }
  },
  data() {
    return {}
  }
}
</script>
<style lang="scss" scoped>
.list-rank {
  background: #fff;
  margin: 0 24px 80px;
  padding: 45px 75px 45px 26px;
  border-radius: 16px;
  .public-main {
    line-height: 1;
    margin-bottom: 12px;
    align-items: center;
    .item-rank {
      width: 108px;
    }
    .list-guest {
      width: 416px;
    }
    .guest-bg {
      height: 120px;
      align-items: center;
      justify-content: left;
      img {
        display: block;
        width: 90px;
        height: 90px;
        border-radius: 50%;
        margin-right: 32px;
      }
    }
    .is-odd {
      background: linear-gradient(
        to right,
        rgba(255, 255, 255, 0) 0%,
        rgba(240, 240, 240, 0.99) 50%,
        rgba(255, 255, 255, 0) 100%
      );
    }
  }
  .title-box {
    margin-bottom: 48px;
  }
}
</style>
